// Referee page
// - Shows Spinner while referees are loading
// - Renders <h1> error if referee is not found

import { useParams } from 'react-router-dom';
import Layout from '../components/Layout';
import RefereeCard from '../components/RefereeCard';
import Spinner from '../components/Spinner';
import { useUser } from '../utils/hooks';
import { UsersRoles } from '../utils/enums';

export default function PageReferee() {
  const { refereeId } = useParams();
  const { entity: found, isResolved } = useUser(refereeId);

  // Find an existing referee by id and role
  const referee = found?.role === UsersRoles.REFEREE ? found : undefined;

  // Spinner only while the record could still show up — the current user's own
  // card is already in usersById, so it renders without waiting for the list
  if (!referee && !isResolved) {
    return (
      <Layout screenSized className='page-referee'>
        <Spinner show />
      </Layout>
    );
  }

  // Not found => plain H1 error
  if (!referee) {
    return (
      <Layout screenSized className='page-referee'>
        <h1>{`Error: no route matches url "/referees/${refereeId}"`}</h1>
      </Layout>
    );
  }

  // Happy path
  return (
    <Layout className='page-referee' trail>
      <RefereeCard referee={referee} />
    </Layout>
  );
}
